import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InvoiceAddComponent } from './invoice-add.component';
import { FinanceDropdownModule } from '../../finance-dropdown/finance-dropdown.module';
import { DatePickerModule } from '../../date-picker/date-picker.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FinanceDropdownModule,
    DatePickerModule,
  ],
  exports: [InvoiceAddComponent],
  declarations: [InvoiceAddComponent],
})
export class InvoiceAddModule {}
